import mergeWith from 'lodash/mergeWith';
import type { MutationTree } from 'vuex';

import { isNullValue } from '@emobg/web-utils';

import type { ClientDataResponse } from '@api/api.model';

import type { BrokerDetails, BrokerState } from './interfaces';

export enum BrokerMutations {
  SetData = 'Broker:SET_DATA',
  SetClientData = 'Broker:SET_CLIENT_DATA',
  UpdateClientData = 'Broker:UPDATE_CLIENT_DATA',
}

export interface BrokerData {
  [BrokerMutations.SetData]: (state: BrokerState, data: BrokerDetails) => void;
  [BrokerMutations.SetClientData]: (state: BrokerState, clientData: ClientDataResponse) => void;
  [BrokerMutations.UpdateClientData]: (state: BrokerState, payload: { param: string; value: string }) => void;
}

export const mutations: MutationTree<BrokerState & BrokerData> = {
  [BrokerMutations.SetData](state, data) {
    state.data.documentsForValidation = [];

    const updatedData = mergeWith({}, state.data, data, (key, value) => (isNullValue(value) ? key : undefined));

    state.data = updatedData;
  },

  [BrokerMutations.SetClientData](state, { clientData, clientDocument }) {
    state.client = { clientData, clientDocument };
  },

  [BrokerMutations.UpdateClientData](state, { prop, value }) {
    state.client.clientData = { ...state.client.clientData, ...{ [prop]: value } };
  },
} as const;
